import LIST_AUCTION_CITY from '../constant/auction-city';
import LIST_BRAND_VEHICLE from '../constant/brand-vehicle';
import LIST_GRADE_VEHICLE from '../constant/grade-vehicle';
import LIST_SERIES_VEHICLE from '../constant/series-vehicle';
import LIST_TRANSMISSION_VEHICLE from '../constant/transmission-vehicle';
import VEHICLE_YEAR from '../constant/vehicle-year';

export const moneyFormatter = (money = 0, usePrefix = true) => {
  // alert(this.value)
  if (money / 1000000000 >= 1) {
    return ((money / 1000000000).toFixed(2) * 100) / 100 + (usePrefix ? ' M' : '');
  } else if (money / 1000000 >= 1) {
    return ((money / 1000000).toFixed(2) * 100) / 100 + (usePrefix ? ' Juta' : '');
  } else {
    return Math.floor(money);
  }
};

// Prevent not a number typing on input type = number firefox, includes e, - . + / ,
export const onlyAllowNumber = (e) => {
  e = e || window.event;
  var charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
  var charStr = String.fromCharCode(charCode);
  if (!charStr.match(/^[0-9]+$/)) e.preventDefault();
};

// replace text and . to empty string
export function replaceNan(e) {
  e.target.value = e.target.value.replace(/[^0-9\.]+/g, '').replace('.', '');
}

export const onlyAllowAlphabet = (e) => {
  e = e || window.event;
  var charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
  var charStr = String.fromCharCode(charCode);
  if (!charStr.match(/^[a-zA-Z ]*$/)) e.preventDefault();
};

export function btnMarketprice(selectedValue, error) {
  if (selectedValue) {
    const { merk, seri, tipe, silinder, periode_data, model, transmisi, grade, startYear, endYear, kota } =
      selectedValue;
    return (
      merk === null ||
      merk === 'label' ||
      seri === null ||
      seri === undefined ||
      seri === 'label' ||
      tipe === null ||
      tipe === undefined ||
      tipe === 'label' ||
      silinder === null ||
      silinder === undefined ||
      silinder === 'label' ||
      periode_data === null ||
      periode_data === undefined ||
      periode_data === '0' ||
      model === null ||
      model === undefined ||
      model === 'label' ||
      transmisi === null ||
      transmisi === undefined ||
      transmisi === 'label' ||
      grade === null ||
      grade === undefined ||
      grade === '0' ||
      startYear === null ||
      startYear === undefined ||
      startYear === 'label' ||
      endYear === null ||
      endYear === undefined ||
      endYear === 'label' ||
      kota === null ||
      kota === undefined ||
      kota === 'label' ||
      error.minKm.error === true ||
      error.maxKm.error === true
    );
  }
}

export function createErrorMsg(status) {
  let message = '';
  switch (status) {
    case 400:
      message = 'Permintaan anda tidak dapat diproses. Bersihkan cookies atau coba lagi menggunakan jaringan lain.';
      break;
    case 401:
      message = 'Email atau password anda salah. Pastikan kredensial anda benar.';
      break;
    case 500:
      message = 'Internal server error.';
      break;
    default:
      break;
  }
  return message;
}

export function createNegStatement(value) {
  let statement = '';
  if (value < 0) {
    statement = 'Pernah';
  } else {
    statement = 'Tidak';
  }
  return statement;
}

export function createPosStatement(value) {
  let statement = '';
  if (value < 0) {
    statement = 'Tidak';
  } else {
    statement = 'Pernah';
  }
  return statement;
}

export function nameChartType(value) {
  let chart = '';
  switch (value) {
    case 0:
      chart = 'Lines';
      break;
    case 1:
      chart = 'Bar';
      break;
    case 2:
      chart = 'Pie';
      break;
    case 3:
      chart = 'Table';
      break;
    case 4:
      chart = 'Geo Map';
      break;
    default:
      break;
  }
  return chart;
}

export function createNewObjInsight(arr) {
  const valuedArr = arr.map((item) => {
    return {
      item_cylinder: item.cylinder,
      item_brand: LIST_BRAND_VEHICLE.filter((e) => e.key === item.brand)[0]?.value,
      item_city: LIST_AUCTION_CITY.filter((e) => e.key === item.city)[0]?.value,
      item_grade: LIST_GRADE_VEHICLE.filter((e) => e.key === item.grade)[0]?.value,
      item_series: LIST_SERIES_VEHICLE.filter((e) => e.key === item.series)[0]?.value,
      item_transmission: LIST_TRANSMISSION_VEHICLE.filter((e) => e.key === item.transmission)[0]?.value,
      item_type: item.type,
      item_year: VEHICLE_YEAR.filter((e) => e.key === item.year)[0]?.value,
    };
  });

  const keys = [];
  valuedArr.forEach((o, index) => {
    Object.keys(o).forEach(function (k) {
      if (k !== `${k}${index}`) {
        k = `${k}${index + 1}`;
        keys.push(k);
      }
    });
  });

  const values = [].concat.apply(
    [],
    valuedArr.map((item) => Object.values(item))
  );

  return Object.assign(...keys.map((k, i) => ({ [k]: values[i] })));
}

export function formatDate(value) {
  let date = new Date(value);
  const day = date.toLocaleString('default', { day: '2-digit' });
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.toLocaleString('default', { year: 'numeric' });
  return day + ' ' + month + ' ' + year;
}

export const setLocalstorageLogin = ({ id, email, name, status, due, distance }) => {

  if (id) {
    localStorage.setItem('id', id);
  }
  if (status) {
    localStorage.setItem('status', status);
  }
  if (due) {

    localStorage.setItem('due', due);
  }

  if (!localStorage.getItem('last_login')) {
    localStorage.setItem('last_login', Date.now());
  }

  if (distance) {

    localStorage.setItem('distance', distance);
  }
};

export const removeLocalstorageLogout = () => {
  localStorage.removeItem('email');
  localStorage.removeItem('id');
  localStorage.removeItem('token');
  localStorage.removeItem('name');
  localStorage.removeItem('status');
  localStorage.removeItem('due');
  localStorage.removeItem('distance');
  localStorage.removeItem('last_login');
  localStorage.removeItem('login_with')
};

export const sleep = (duration) => {
  return new Promise((resolve) => {
    setTimeout(resolve, duration)
  })
}